"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Head_1 = require("./Head");
exports.Head = Head_1.default;
//# sourceMappingURL=index.js.map